import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { api } from "@/lib/api";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [tagline, setTagline] = useState("Independent Christian School · Berry, AL");
  const location = useLocation();
  const onEnroll = location.pathname.startsWith("/enroll");

  useEffect(() => {
    api.get("/settings")
      .then((r) => { if (r.data?.header_tagline) setTagline(r.data.header_tagline); })
      .catch(() => {});
  }, []);

  const navItems = [
    { label: "Home", href: "/#home" },
    { label: "Vision", href: "/#vision-mission" },
    { label: "How It Works", href: "/#how-it-works" },
    { label: "Tuition", href: "/#tuition" },
    { label: "FAQ", href: "/#faq" },
    { label: "Contact", href: "/#contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 w-full bg-white/95 backdrop-blur-md border-b border-grey"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src="/zca-logo.png"
            alt="Zion Christian Academy"
            className="h-11 w-11 object-contain"
          />
          <div className="hidden sm:block leading-tight">
            <div className="h-serif text-lg text-purple-dark tracking-tight">
              Zion Christian Academy
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-purple-light font-bold" data-testid="header-tagline">
              {tagline}
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="text-sm text-ink hover:text-purple transition-colors link-underline"
              data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {it.label}
            </a>
          ))}
          {!onEnroll && (
            <Link
              to="/enroll"
              data-testid="header-enroll-cta"
              className="bg-gold text-ink hover:bg-gold-light font-bold px-6 py-2.5 rounded-sm transition-colors text-sm"
            >
              Start Enrollment
            </Link>
          )}
          <Link
            to="/portal/login"
            data-testid="header-portal-link"
            className="text-sm text-purple hover:text-purple-dark font-bold link-underline"
          >
            Parent Portal
          </Link>
        </nav>

        <button
          className="md:hidden text-purple-dark"
          onClick={() => setOpen(!open)}
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-grey bg-white px-5 py-4 space-y-3">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              onClick={() => setOpen(false)}
              className="block text-ink hover:text-purple text-sm"
              data-testid={`mobile-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {it.label}
            </a>
          ))}
          <Link
            to="/enroll"
            onClick={() => setOpen(false)}
            className="block bg-gold text-ink font-bold px-6 py-2.5 rounded-sm text-sm text-center"
            data-testid="mobile-enroll-cta"
          >
            Start Enrollment
          </Link>
          <Link
            to="/portal/login"
            onClick={() => setOpen(false)}
            className="block text-purple hover:text-purple-dark text-sm font-bold"
            data-testid="mobile-portal-link"
          >
            Parent Portal
          </Link>
        </div>
      )}
    </header>
  );
}
